<template lang="pug">
    el-dialog(title="查看详情",width="95%",:append-to-body='true' :visible.sync='visible' :modal-append-to-body='false' @close="closeForm()")
      el-form(:model="ruleForm", :inline="false" , ref="ruleForm", label-width="100px", @submit.native.prevent)
          el-card(shadow="never")
            div(slot="header")
                font(style="font-weight: bold;font-size:18px;") 面向群体
            div
                el-form-item(label="会员类型:" prop="types")
                  font() {{ruleForm.types}}
                el-form-item(label="性别选择:" prop="genders")
                  font() {{ruleForm.genders}}
                el-form-item(label="会员级别:" prop="levels")
                  font() {{ruleForm.levels}}
                el-form-item(label="特定人群:" prop="matchName")
                  el-table( style="width: 100%"  border :data="ruleForm.tabData")
                    el-table-column(prop='name',header-align='center',align='center',label='姓名')
                    el-table-column(prop='mobile',header-align='center',align='center',label='手机')
                    el-table-column(prop='idCard',header-align='center',align='center',label='身份证')
          el-card(shadow="never" style='margin-top:20px;')
            div(slot="header")
               font(style="font-weight: bold;font-size:18px;") 基础设置
            div
               el-form-item(label="推送方式:" prop="byx1")
                  font() {{ruleForm.byx1}}
               el-form-item(label="消息类型:" prop="type" )
                  font() {{ruleForm.type}}
          el-card(shadow="never" style='margin-top:20px;')
            div(slot="header")
               font(style="font-weight: bold;font-size:18px;") 消息推送
            div
               el-form-item(label="消息标题:" prop="content" )
                  font() {{ruleForm.title}}
               el-form-item(label="推送内容:" prop="content" )
                  font() {{ruleForm.content}}
      span.dialog-footer(slot="footer")
          el-button(@click="closeForm()") 返回

</template>
<script>
const mbOptions = ['注册会员', '初始会员', '荣誉会员']
const sexOptions = ['男', '女']
const levelOptions = ['0.0', '1.0', '1.5', '2.0', '2.5', '3.0', '3.5', '4.0', '4.5', '5.0']
export default {
  data () {
    return {
      visible: false,

      ruleForm: {
        types: '',
        genders: '',
        levels: '',
        tabData: [],
        byx1: '',
        type: '',
        content: '',
        title: ''
      }
    }
  },

  mounted () {

  },
  methods: {
    init (id, flagType) {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['ruleForm'].resetFields()
      })
      //数据初始化
      if (id) {
        this.$http({
          url: this.$http.adornUrl(`/pbMessage/getId/${id}`),
          method: 'get'
        }).then(data => {
          if (data && data.code === 0) {
            let types = ''
            if (data.bean.mbTypes) {
              data.bean.mbTypes.split(',').forEach(e => {
                types += { 1: '注册会员', 2: '初始会员', 3: '荣誉会员' }[e] + '   '
              })
            }
            this.ruleForm.types = types
            this.ruleForm.genders = { 0: '男', 1: '女', '0,1': '男，女' }[data.bean.mbGenders]
            this.ruleForm.levels = data.bean.mbLevels
            this.ruleForm.tabData = data.list
            this.ruleForm.byx1 = { 1: '站内消息', 2: '手机短信', '1,2': '站内消息,手机短信' }[data.bean.byx1]
            this.ruleForm.type = { 1: '竞赛', 2: '培训' }[data.bean.type]
            this.ruleForm.content = data.bean.content
            this.ruleForm.title = data.bean.title
          }
        })
      }
    },
    closeForm () {
      this.visible = false
    }

  }
}
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.width_ct {
  width: 50%;
}
.sel_width_ct,
.input_width_ct {
  width: 20% !important;
}
.font_later {
  padding-left: 20px;
  font-weight: bold;
  color: #909399;
}
.font_color {
  font-weight: bold;
  color: #909399;
}
.font_style {
  font-weight: bold;
  color: red;
}
.dialog-footer {
  padding-bottom: 150px;
}

</style>
